/*
* @author 友人a丶
* @date 2022-07-11
* 全局接口
* */

const BASE_URL = import.meta.env.PROD ? "/" : "/api";

export default {
    /* 全局host */
    host: BASE_URL,
    /* 用户头像 */
    avatar: "https://pddapi.xuanmaidianzishangwu.top/api/v1/avatar?text=",
    user_article_count: "/user/users/article_count",
    user_article_list: "/user/users/article_list",
    user_article_un: "/user/users/article_un",
    /* 用户登录 */
    login: {
        user: `/user/login/index`,
        verify: `/user/login/getverify`,
        info: `/user/users/index`,
        getInfo: `/index/index/getInfo`,
        getInfo2: `/index/index/getInfo6`,
        config: `/user/users/getWebsiteConfig`,
        password: `/user/users/updatePassword`
    },
    dash: {
        /* 图表 */
        dash_chart: `/user/users/getlinechart`,
        /*统计信息*/
        dash_statistics: `/user/users/index`,
        /* 每日签到 */
        sign: `/user/users/signin`,
        kuaiqu: `/user/users/kuaiqu`,
        /* 充值 */
        charge: `/user/order/create`,
        /* 首充 */
        firstCharge: `/user/users/getFirstChargePackage`,
        /* 会员礼包列表 */
        vipList: `/user/ranks`,
        /* 会员礼包列表 */
        buyVip: `/user/ranks/buy`,
    },
    game: {
        save: {
            status: `/user/InvSave/index`,
            ok: `/user/InvSave/save`,
            isExitGame: `/user/game/isExit`,
            isExistDino: `/user/game/isExistDino`
        },
        repo: {
            index: `/user/Inv/index`,
            list: `/user/Inv/get`,
            take: `/user/Inv/take`,
            takefast: `/user/Inv/takefast`,
        },
    },
    clan: {
        repos: {
            list: `/user/clan/clanInv`,
            refresh: `/user/clan/giveLong`,
            log: `/user/clan/giveLonglog`
        },
        clans: {
            list: `/user/clan/index`,
            apply: `/user/clan/applyJoinClan`,
            create: `/user/clan/create`,
            my: `/user/clan/myClan`,
            buyCreate: '/user/clan/buyClanCreateAuth'
        },
        admin: {
            list: `/user/clan/clanJoinList`,
            destroy: `/user/clan/divideClan`,
            agree: `/user/clan/joinReqAdmin`,
            upgrade: `/user/clan/upgradeClan`,
            exit: `/user/clan/exitClan`
        },
        reqLogs: {
            list: `/user/clan/reqLogs`
        },
        member: {
            list: `/user/clan/clanPlayerList`,
            repos: `/user/clan/setAdminInv`,
            remove: `/user/clan/kick`,
            second: `/user/clan/setAdmin`,
            list2: `/user/Activity/dynamicByPlayer`,
        },
        my: {
            info: `/user/clan/myClan`,
        }
    },
    shop: {
        gift: {
            list: `/user/shop/giftShop`,
            buy: `/user/shop/giftBuy`
        },
        clan: {
            list: `/user/shop_clan`,
            buy: `/user/shop_clan/buy`
        },
        longs: {
            list: `/user/shop/index`,
            buyLong: `/user/shop/buyLong`,
            buyLonglb: `/user/shop/buyLonglb`,
            buyLongVoucher: `/user/shop/buyLongVoucher`,
            buyLongGMoney: `/user/shop/buyLongGMoney`
        },
        skins: {
            list: `/user/shop/skins`,
            buy: `/user/shop/buySkin`,
            buyV: `/user/shop/buySkinVoucher`,
            buyG: `/user/shop/buySkinGMoney`,
        },
        super: {
            list: `/user/shop/cjskins`,
            buy: `/user/shop/buycjSkin`,
            buyV: `/user/shop/buycjSkinVoucher`,
            buyG: `/user/shop/buycjSkinGMoney`,
        },
        texiao: {
            list: `/user/shop/texiao`,
            buy: `/user/shop/buyTx`,
            buyV: `/user/shop/buyTxVoucher`,
            buyG: `/user/shop/buyTxGMoney`,
        },
        ability: {
            list: `/user/shop/ability`,
            buy: `/user/shop/buyAbility`,
            buyV: `/user/shop/buyAbilityVouche`,
            buyG: `/user/shop/buyAbilityGMoney`,
        },
        color: {
            list: `/user/shop/tsbSkins`,
            buyV: `/user/shop/buyTsbVoucher`,
            buyG: `/user/shop/buyTsbGMoney`,
            buyJ: `/user/shop/buyTsbJifen`,
        },
        colorname: {
            list: `/user/colorname/colorname`,
            buy: `/user/colorname/buyColorItem`,
            getUser: `/user/colorname/getUserColorItems`,
            getPurchased: `/user/colorname/getUserPurchasedColors`,
            switch: `/user/colorname/switchColorItem`
        },
        colortext: {
            list: `/user/colorname/colortext`,
            buy: `/user/colorname/buyColorItem`
        },
        supercolorname: {
            list: `/user/colorname/supercolorname`,
            buy: `/user/colorname/buyColorItem`
        },
        supercolortext: {
            list: `/user/colorname/supercolortext`,
            buy: `/user/colorname/buyColorItem`
        },
    },
    data: {
        list: '/user/allkonglongdata'
    },
    rank: {
        kill: `/user/ranking/kill`,
        death: `/user/ranking/death`,
        online: `/user/ranking/online`,
        recharge: `/user/ranking/recharge`,
        longbi: `/user/ranking/longBi`,
        longhun: `/user/ranking/longhun`,
        jifen: `/user/ranking/economy`,
        repos: `/user/ranking/inventory`
    },
    record: {
        deaths: {
            list: `/user/record/death`,
        },
        chat: {
            list: `/user/record/chat`,
        },
        ban: {
            list: `/user/record/banlog`
        },
        quite: {
            list: `/user/record/jinyanlog`
        }
    },
    active: {
        day: `/user/activity/getDayKits`,
        vip: `/user/activity/getVipKits`,
        rewu: `/user/activity/renwuDayLingqu`,
        libao: `/user/activity/renwuVipLibaoLingqu`,
    },
    prize: {
        pools: {
            list: `/user/draw`,
            get: `/user/draw/get`,
            buy: `/user/order/create`,
            gBuy: `/user/draw/buy`,
            pay: `/user/order/pay`,
            draw: '/user/draw/savedraw',
            status: `/user/order/orderstate`,
            cash: `/user/knapsack/give`
        },
        bag: {
            list: `/user/knapsack/index`,
            longs: `/user/knapsack/getKonglong?type=`,
            voucher: `/user/voucher`,
            skins: `/user/knapsack/getskinstx`,
        },
        frag: {
            give: '/user/knapsack/giveDebris',
            debris: '/user/knapsack/debris',
            debrisType: 'user/Knapsack/debrisType'
        }
    },
    routes: {
        list: "/user/menu/index",
        raw: "/user/menu/raw",
        menu: "/user/set_menu",
        del: "/user/menu/delete",
        edit: "/user/menu/save",
    },
    dinoHatch: {
        list: `/user/dinohatch/getHatchList`,
        dinosaurs: `/user/dinohatch/getAvailableDinosaurs`,
        start: `/user/dinohatch/startHatch`,
        claim: `/user/dinohatch/claimDinosaur`,
        cancel: `/user/dinohatch/cancelHatch`
    },
    pvp: {
        players: `/user/pvp/players`,
        list: `/user/pvp/list`,
        info: `/user/pvp/info`,
        kits: `/user/pvp/kits`,
        claim: `/user/pvp/claim`,
        claimStatus: `/user/pvp/claimStatus`,
        rank: `/user/pvp/rank`,
        myRank: `/user/pvp/myRank`
    },
    message: {
        getUnread: `/user/game/getUnreadMessages`,
        getHistory: `/user/game/getHistoryMessages`,
        markRead: `/user/game/markMessageRead`,
        claimBenefits: `/user/game/claimMessageBenefits`
    },
    map: {
        position: `/user/users/getPlayerPosition`,
        territories: `/user/clan/getLingdiCircles`,
        teamPlayers: `/user/users/getTeamPlayersPosition`
    },
    suipian: {
        balance: `/user/suipian/getBalance`,
        prizeList: `/user/suipian/getPrizeList`,
        exchange: `/user/suipian/exchange`,
        exchangeLog: `/user/suipian/getExchangeLog`,
        giftLog: `/user/suipian/getGiftLog`,
        gift: `/user/suipian/gift`
    }
}